module.exports = __webpack_public_path__ + "img/production.31f17f91.png";